import DateFormat from './utilities/date-format';

export default class Header {

	static getHolderSelectors = () => ['header'];

	/** @type {HTMLElement} */
	#holderElement;

	/** @type {Pikaday} */
	#checkInDatePicker;

	/** @type {Pikaday} */
	#checkOutDatePicker;

	/** @param {HTMLElement} holderElement */
	constructor(holderElement) {
		this.#holderElement = holderElement;

		this.#setNavBar();
		this.#setSideMenu();
		this.#setBooking();

		this.#holderElement.querySelector('.overlay').addEventListener('click', (e) => {
			this.#closeSideMenu(e);
			this.#closeBooking(e);
		});
	}

	#setNavBar() {
		if (!document.querySelector('.hero-element') && !document.querySelector('.room-nav-bar-element')) {
			document.querySelector('.header-position-holder').style.height = this.#holderElement.offsetHeight/16 + 'rem';
		}

		if (document.querySelector('.room-nav-bar-element')) {
			this.#holderElement.style.position = 'initial';
		}

		this.#holderElement.querySelectorAll('.btn-menu-col').forEach(menuIcon => {
			menuIcon.addEventListener('click', () => {
				menuIcon.querySelector('.menu-icon').classList.toggle('open');
			});
		});
	}

	#setSideMenu() {
		this.#holderElement.querySelector('.btn-side-menu').addEventListener('click', (e) => {
			this.#openSideMenu(e);
		});

		this.#holderElement.querySelector('.close-side-menu').addEventListener('click', (e) => {
			this.#closeSideMenu(e);
		});
	}

	#setBooking() {
		const arrivalInput = this.#holderElement.querySelector('[name="arr"]');
		const nightsInput = this.#holderElement.querySelector('[name="nts"]');

		this.#holderElement.querySelectorAll('.btn-booking').forEach(btnBooking => {
			btnBooking.addEventListener('click', (e) => {
				this.#openBooking(e);
			});
		});

		this.#holderElement.querySelector('.close-booking').addEventListener('click', (e) => {
			this.#closeBooking(e);
		});

		let checkInField = this.#holderElement.querySelector('.check-in-field');
		let checkOutField = this.#holderElement.querySelector('.check-out-field');

		this.#checkInDatePicker = new Pikaday({
			field: checkInField,
			minDate: new Date(),
			onSelect: (date) => {
				checkInField.value = DateFormat.format(date, DateFormat.CALENDAR);
				checkInField.dataset.date = DateFormat.format(date, DateFormat.ISO_8601);
				arrivalInput.value = DateFormat.format(date, DateFormat.ISO_8601);

				if (this.#checkOutDatePicker.getDate() < this.#checkInDatePicker.getDate()) {
					this.#checkOutDatePicker.setDate(DateFormat.addDays(date, 2));
				}
			},
		});

		this.#checkOutDatePicker = new Pikaday({
			field: checkOutField,
			minDate: new Date(),
			onSelect: (date) => {
				checkOutField.value = DateFormat.format(date, DateFormat.CALENDAR);
				checkOutField.dataset.date = DateFormat.format(date, DateFormat.ISO_8601);

				if (!arrivalInput.value) {
					return;
				}
				nightsInput.value = DateFormat.nights(date, new Date(arrivalInput.value));
			},
		});

		this.#checkInDatePicker.setDate(new Date());
		this.#checkOutDatePicker.setDate(DateFormat.addDays(new Date(), 2));

		let bookingSwitchTab = this.#holderElement.querySelector('.booking-switch-tab');

		bookingSwitchTab.querySelector('.today').addEventListener('click', () => {
			this.#handleTabSelection(bookingSwitchTab.querySelector('.today'));
			this.#checkInDatePicker.setDate(new Date());
			this.#checkOutDatePicker.setDate(DateFormat.addDays(new Date(), 2));
		});

		bookingSwitchTab.querySelector('.tomorrow').addEventListener('click', () => {
			this.#handleTabSelection(bookingSwitchTab.querySelector('.tomorrow'));
			this.#checkInDatePicker.setDate(DateFormat.addDays(new Date(), 1));
			this.#checkOutDatePicker.setDate(DateFormat.addDays(new Date(), 3));
		});

		bookingSwitchTab.querySelector('.weekend').addEventListener('click', () => {
			let today = new Date();
			let day = today.getDay();
			let saturday;
			let sunday = new Date();

			if (day === 0 || day === 6) {
				saturday = today;
				sunday.setDate(saturday.getDate() + (day === 0 ? 0 : 1));
			} else {
				saturday = new Date(today.getFullYear(), today.getMonth(), (today.getDate() + 6) - day);
				sunday.setDate(saturday.getDate() + (saturday.getDay() === 0 ? 0 : 1));
			}

			this.#handleTabSelection(bookingSwitchTab.querySelector('.weekend'));
			this.#checkInDatePicker.setDate(saturday);
			this.#checkOutDatePicker.setDate(sunday);
		});

		let hiddenField = this.#holderElement.querySelector('.booking-form-hidden');

		// this.#holderElement.querySelector('.submit').addEventListener('click', (e) => {
		// 	e.preventDefault();
		// 	hiddenField.innerHTML = '';
		//
		// 	this.#holderElement.querySelector('.booking-form').querySelectorAll('.field').forEach(field => {
		// 		let key = field.getAttribute('name').toLowerCase();
		// 		let value;
		//
		// 		if (field.classList.contains('date-picker')) {
		// 			value = field.dataset.date;
		// 		} else if (field.classList.contains('quantity')) {
		// 			value = field.value;
		// 		}
		// 		hiddenField.innerHTML += `<input type="hidden" name="` + key + `" value="` + value + `">`;
		// 	});
		//
		// 	hiddenField.submit();
		// });
	}

	/** @param {HTMLElement} element */
	#handleTabSelection(element) {
		this.#holderElement.querySelector('.booking-switch-tab').querySelector('.active').classList.remove('active');
		element.classList.add('active');
	}

	/** @param {Event} e */
	#openSideMenu(e) {
		e.preventDefault();
		this.#holderElement.querySelector('.side-menu').classList.add('show');
		this.#holderElement.querySelector('.overlay').style.visibility = 'visible';
		this.#holderElement.querySelector('.overlay').style.opacity = 1;
		document.querySelector('body').style.overflow = 'hidden';
	}

	/** @param {Event} e */
	#closeSideMenu(e) {
		e.preventDefault();
		this.#holderElement.querySelector('.side-menu').classList.remove('show');
		this.#holderElement.querySelector('.overlay').style.visibility = 'hidden';
		this.#holderElement.querySelector('.overlay').style.opacity = 0;
		document.querySelector('body').style.overflow = 'unset';
	}

	/** @param {Event} e */
	#openBooking(e) {
		e.preventDefault();
		this.#holderElement.querySelector('.booking').classList.add('show');
		this.#holderElement.querySelector('.overlay').style.visibility = 'visible';
		this.#holderElement.querySelector('.overlay').style.opacity = 1;
		document.querySelector('body').style.overflow = 'hidden';
	}

	/** @param {Event} e */
	#closeBooking(e) {
		e.preventDefault();
		this.#holderElement.querySelector('.booking').classList.remove('show');
		this.#holderElement.querySelector('.overlay').style.visibility = 'hidden';
		this.#holderElement.querySelector('.overlay').style.opacity = 0;
		document.querySelector('body').style.overflow = 'unset';
	}

}
